import React from "react";
import { Primary } from "../../stories/Buttons/Button.stories";
import PropTypes from "prop-types";
const BackButton = ({ onClick }) => {
  return (
    <div className="container p-0 back-btn-wrapper">
      <div className="row">
        <div className="col-md-12">
          <Primary
            className="d-block btn-back"
            label="Back"
            onClick={onClick}
            size="small"
            variant="outline"
          />
        </div>
      </div>
    </div>
  );
};
BackButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};
export default BackButton;
